import React, { useState } from "react";
import { SlideoutDrawerV2, Flex, Tabs, Tab, OverlayStyle } from "@jsq/ds/core";
import { useFeatureFlag } from "@jsq/flags-react";
import { ControlTowerContext } from "#utils/context";
import { useControlTowerContext } from "../ControlTowerContext";
import { getOriginFromUrl } from "../utils";
import { ClientCommunicationsTab } from "./ClientCommunicationsTab";
import { RequestDetailsTab } from "./RequestDetailsTab";
import * as styles from "./styles_vanilla.css";
import { TasksTab } from "./TasksTab";
import { WorkflowDetailsDrawerProps, TabType } from "./types";
import { WorkflowDetailsHeader } from "./WorkflowDetailsHeader";

export const WorkflowDetailsDrawer: React.FC<WorkflowDetailsDrawerProps> = ({
  workflow,
  onClose,
}) => {
  const [activeTab, setActiveTab] = useState<TabType>(TabType.Tasks);
  const context = useControlTowerContext();
  const isGPX = context === ControlTowerContext.GPX;
  const isClientCommunicationsEnabled = useFeatureFlag(
    "showCanpoyControlTowerClientCommunicationsTab",
    false,
  );

  if (!workflow) {
    return null;
  }

  return (
    <SlideoutDrawerV2
      isOpen={!!workflow}
      onClose={onClose}
      isDismissable
      overlayStyle={OverlayStyle.Opaque}
      data-testid="workflow-details-drawer"
    >
      <Flex alignItems="flex-start" justifyContent="center" className={styles.drawerBody}>
        <Flex
          flexDirection="column"
          className={
            isGPX ? `${styles.drawerContent} ${styles.drawerContentGPX}` : styles.drawerContent
          }
        >
          <div className={styles.headerSection}>
            <WorkflowDetailsHeader workflow={workflow} onClose={onClose} />
          </div>
          <div className={styles.tabsContainer}>
            <Tabs>
              <Tab
                active={activeTab === TabType.Tasks}
                text="Tasks"
                onClick={() => setActiveTab(TabType.Tasks)}
                data-testid="tasks-tab"
              />
              {isClientCommunicationsEnabled && (
                <Tab
                  active={activeTab === TabType.ClientCommunications}
                  text="Client Communications"
                  onClick={() => setActiveTab(TabType.ClientCommunications)}
                  data-testid="client-communications-tab"
                />
              )}
              <Tab
                active={activeTab === TabType.RequestDetails}
                text="Request details"
                onClick={() => setActiveTab(TabType.RequestDetails)}
                data-testid="request-details-tab"
              />
            </Tabs>
          </div>
          <div className={styles.tabContent}>
            {activeTab === TabType.Tasks && (
              <TasksTab
                parentIssueKey={workflow.key}
                jiraBaseURL={getOriginFromUrl(workflow.jiraLink)}
              />
            )}
            {isClientCommunicationsEnabled && activeTab === TabType.ClientCommunications && (
              <ClientCommunicationsTab
                issueKey={workflow.key}
                jiraBaseURL={getOriginFromUrl(workflow.jiraLink)}
              />
            )}
            {activeTab === TabType.RequestDetails && (
              <RequestDetailsTab issueKey={workflow.key} />
            )}
          </div>
        </Flex>
      </Flex>
    </SlideoutDrawerV2>
  );
};
